import React from 'react';
import { InstalledBadge } from '../installed-badge';
import type { PricingBadgeProps } from '../pricing-badge';
import { PricingBadge } from '../pricing-badge';
import { useEssentials } from '../../contexts/essentials-context';
import { SetupIncompleteBadge } from '../setup-incomplete-badge';
import { PremiumSiteRequiredBadge } from '../premium-site-required-badge';
import { Text } from '@wix/design-system';

export interface AppBottomBadgeProps {
  isAppInstalled: boolean;
  isAppSetupIncomplete: boolean;
  isBundleApp: boolean;
  pricing: PricingBadgeProps;
  isAppRequiresPremiumSite: boolean;
  options?: {
    showPricing?: boolean;
    showPremiumRequired?: boolean;
  };
}

export function AppBottomBadge({
  isAppInstalled,
  isAppSetupIncomplete,
  isBundleApp,
  pricing,
  isAppRequiresPremiumSite,
  options = {},
}: AppBottomBadgeProps) {
  const { t } = useEssentials();
  const { showPricing = true, showPremiumRequired = true } = options;

  if (isBundleApp && !isAppInstalled) {
    return (
      <Text size="tiny" weight="thin" skin="success" secondary>
        {t('app.pricing.bundle-free')}
      </Text>
    );
  }

  if (isBundleApp && isAppInstalled) {
    return (
      <InstalledBadge>
        {t('solutionBox.solutionBottomActionBar.BundleInstalled')}
      </InstalledBadge>
    );
  }

  if (isAppRequiresPremiumSite && showPremiumRequired) {
    return <PremiumSiteRequiredBadge />;
  }

  if (isAppSetupIncomplete) {
    return <SetupIncompleteBadge />;
  }

  if (isAppInstalled) {
    return (
      <InstalledBadge>
        {t('solutionBox.solutionBottomActionBar.installedSolution')}
      </InstalledBadge>
    );
  }

  if (showPricing) {
    return <PricingBadge {...pricing} />;
  }

  return null;
}
